import { GroupSecurity } from '@quromedical/fhir-common';
import type { PatientRouteParams } from 'app/routes';
import { PatientHeaderSection } from 'core/patient';
import { Tabs } from 'design-system';
import { useGlobalSearchParams } from 'expo-router';
import { useUserSession } from 'hooks/useUserSession';
import type { PatientDrawerScreenProps } from 'navigation';
import type React from 'react';
import { ScrollView } from 'react-native';
import { strings } from 'strings';
import {
  PatientAdmissionsTab,
  PatientAllergyTab,
  PatientConsumableTab,
} from './tabs';

export const PatientClinicalScreen: React.FC<
  PatientDrawerScreenProps<'Clinical'>
> = () => {
  const { patientId } = useGlobalSearchParams<PatientRouteParams>();
  const session = useUserSession();

  const hasConsumablePermissions = session.hasAny([
    GroupSecurity.ChargeItemRead,
  ]);

  const hasAdmissionPermissions = session.hasAny([GroupSecurity.EncounterRead]);

  const hasAllergyPermissions = session.hasAny([
    GroupSecurity.AllergyIntoleranceRead,
  ]);

  return (
    <ScrollView>
      <PatientHeaderSection id={patientId} />
      <Tabs.Group>
        <Tabs.Screen
          isHidden={!hasAdmissionPermissions}
          title={strings.AdmissionCardTitle}
        >
          <PatientAdmissionsTab patientId={patientId} />
        </Tabs.Screen>

        <Tabs.Screen
          isHidden={!hasConsumablePermissions}
          title={strings.LabelConsumable}
        >
          <PatientConsumableTab patientId={patientId} />
        </Tabs.Screen>

        <Tabs.Screen
          isHidden={!hasAllergyPermissions}
          title={strings.AllergyLabel}
        >
          <PatientAllergyTab patientId={patientId} />
        </Tabs.Screen>
      </Tabs.Group>
    </ScrollView>
  );
};
